import { UIConstants } from "../uiconstants.js";

export class UIStreamerGraphics extends Phaser.Graphics {
    constructor(game) {
        // Call super.
        super(game, 0, 0);

        this.colour = 0x00ff00;

        this.front = this.addChild(new Phaser.Sprite(game, 0, 0));
        this.front.anchor.setTo(0.5, 0.5);

        // Set up UI Physics body.
        this.game.physics.arcade.enable(this.front);
        this.front.body.checkCollision.none = true;
        this.front.body.gravity.y = UIConstants.PLAYER_PANEL_GRAVITY;

        // State.
        this.streamerPositions = [];
        this.timeAlive = 0.0;

        // Disable streamers.
        this.kill();
    }

    update() {
        // Check if exists.
        if (!this.exists) {
            return;
        }

        this.timeAlive += this.game.time.delta / 1000;

        // Add next position.
        const nextX = this.front.x;
        const nextY = this.front.y;
        const xDiff = this.streamerPositions.at(-1).x - nextX;
        const yDiff = this.streamerPositions.at(-1).y - nextY;
        const length = Math.sqrt((xDiff * xDiff) + (yDiff * yDiff));
        this.streamerPositions.push({ x: nextX, y: nextY, length });

        // Draw graphics.
        this.clear();

        this.lineStyle(UIConstants.STREAMER_WIDTH, this.colour, 1.0);

        let lengthSum = 0.0;
        if (this.streamerPositions.length >= 2) {
            let i = this.streamerPositions.length - 1;
            this.moveTo(this.streamerPositions[i].x + (Math.sin(lengthSum * UIConstants.STREAMER_FREQUENCY) * UIConstants.STREAMER_AMPLITUDE_X), this.streamerPositions[i].y + (Math.cos(lengthSum * UIConstants.STREAMER_FREQUENCY) * UIConstants.STREAMER_AMPLITUDE_Y));
            lengthSum += this.streamerPositions[i].length;
            for (; i >= 0; --i) {
                this.lineTo(this.streamerPositions[i].x + (Math.sin(lengthSum * UIConstants.STREAMER_FREQUENCY) * UIConstants.STREAMER_AMPLITUDE_X), this.streamerPositions[i].y + (Math.cos(lengthSum * UIConstants.STREAMER_FREQUENCY) * UIConstants.STREAMER_AMPLITUDE_Y));
                lengthSum += this.streamerPositions[i].length;
            }
        }
    }

    spawn(x, y, colour) {
        // Revive the graphics.
        this.revive();

        // Clear graphics.
        this.clear();

        this.front.reset(x, y);
        const speed = UIConstants.STREAMER_MIN_SPEED + (Math.random() * (UIConstants.STREAMER_MAX_SPEED - UIConstants.STREAMER_MIN_SPEED));
        const direction = UIConstants.STREAMER_MIN_ANGLE + (Math.random() * (UIConstants.STREAMER_MAX_ANGLE - UIConstants.STREAMER_MIN_ANGLE));
        const speedX = Math.cos(direction) * speed;
        const speedY = Math.sin(direction) * speed;

        this.front.body.rotation = Math.random() * Math.PI * 2.0;
        this.front.body.velocity.x = speedX;
        this.front.body.velocity.y = speedY;

        // Store colour.
        this.colour = colour;

        // Reset state.
        this.streamerPositions = [];
        this.streamerPositions.push({ x, y, length: 0.0 });
        this.timeAlive = 0.0;
    }

    remove() {
        // Kill the sprite.
        this.front.kill();
    }

    retire() {
        // Kill the sprite.
        this.front.kill();
        // Kill the graphics.
        this.kill();
    }
}
